PJQ.views.rfq.RFQBatchModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-rfq-batch'),
        maxWidth: 1200,
        isShowCloseButton: true,
        onSave: _.noop()
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .cb-send': 'sendChanged',
        'click .cb-send-all': 'sendAllChanged',
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.batch = {
            changeRequestId: this.options.changeRequest?.id ?? 0,
            title: this.options.changeRequest ? (this.options.changeRequest.get('number') + ' - ' + this.options.changeRequest.get('title')) : '',
            description: this.options.changeRequest?.get('description') ?? '',
            dueDate: new Date(),
            attachments: new PJQ.collections.rfq.Attachments(),
            requests: _.map(this.options.lineItems ?? [], (lineItem) => {
                let vendor = lineItem.get('vendor');
                return {
                    id: lineItem.id,
                    changeRequestId: lineItem.get('changeRequestId'),
                    lineItem: lineItem,
                    lineItemId: lineItem.id,
                    scope: lineItem.get('description'),
                    contractedContact: vendor,
                    contractedContactId: vendor?.id,
                    assignees: vendor != null ? [vendor] : [],
                    assigneeIds: vendor != null ? [vendor.id] : [],
                    distributeToIds: PJQ.app.session.user != null ? [-PJQ.app.session.user.id] : [],
                    commitmentId: lineItem.get('commitmentId'),
                    commitmentNumber: lineItem.get('commitmentNumber'),
                    send: true
                };
            })
        }

        this.isFetched = true;
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            batch: this.batch,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderForm();

        this.renderDataTable();
    },
    sendAllChanged: function (e) {
        let $target = $(e.currentTarget),
            checked = $target.prop('checked');
        _.each(this.batch.requests, (request) => {
            let checkbox = this.$('.cb-send[data-id="' + request.id + '"]');
            checkbox.prop('checked', checked);
            request.send = checked;
        });
    },
    renderForm: function () {
        if (!this.binder) {
            this.binder = new PJQ.Binder(this.$('.details-outer'), this.batch, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });
        }

        new PJQ.inputs.Datepicker({
            el: this.$('.input-due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.batch.dueDate
            },
            onChange: (newDate) => {
                this.batch.dueDate = newDate;
            }
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.rfq-file-uploader'),
            collection: this.batch.attachments,
            useApiV2: true,
            onDelete: (attachment, callback) => {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                callback();
            }
        });
    },
    renderInputs: function () {
        if (!this.lineBinder) {
            this.lineBinder = new PJQ.Binder(this.$el, this.batch.requests, {
                delegate: true,
                modelSelectorAttribute: 'id',
                idAttribute: 'id',
                watchElements: [
                    'input'
                ],
                afterChange: (el, attribute, value) => {
                    let $el = $(el),
                        id = $el.data('id'),
                        model = _.findWhere(this.batch.requests, {
                            id: id
                        });

                    if (model) {
                        model[attribute] = value;
                    }
                }
            });
        }
        let fnCommitmentToChoice = (commitment) => {
            return {
                id: commitment.id,
                name: '<strong>' + commitment.get('number') + '</strong>' + ' | ' + PJQ.helpers.formatHelpers.formatCurrency(commitment.getGrandTotal()),
                subtext: commitment.contractedContact?.get('companyName') ?? ''
            };
        };
        this.commitmentPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.batch.requests, {
            pickerSelector: '.select-commitment',
            valueAttribute: 'commitmentId',
            idAttribute: 'id',
            selectPickerOptions: {
                isBlockSubtext: true,
                size: 5,
                choices: (model) => {
                    if (model.lineItem.get('costCodeId') > 0) {
                        let suggested = [],
                            others = [];
                        _.each(this.options.projectCommitments.models, (commitment) => {
                            if (null != commitment.lineItems.findWhere({
                                costCodeId: model.lineItem.get('costCodeId')
                            })) {
                                suggested.push(commitment);
                            } else {
                                others.push(commitment);
                            }
                        });
                        if (_.size(suggested) > 0) {
                            return [{
                                name: 'Suggested',
                                choices: _.map(suggested, fnCommitmentToChoice)
                            }, {
                                name: '',
                                choices: _.map(others, fnCommitmentToChoice)
                            }];
                        }
                    }
                    return _.map(this.options.projectCommitments.models, fnCommitmentToChoice);
                }
            },
            onChange: (model, value) => {
                let commitment = this.options.projectCommitments.get(value);
                model.commitment = commitment;
                model.commitmentId = commitment?.id;
                model.commitmentNumber = model.commitment?.get('number');
                model.contractedContact = commitment.contractedContact;
                model.contractedContactId = model.contractedContact?.id;
                model.assignees = commitment.contractedContact ? [commitment.contractedContact] : [];
                model.assigneeIds = commitment.contractedContact ? [commitment.contractedContact?.id] : [];
                this.renderDataTable();
            }
        });

        let fnVendorToChoice = (commitment) => {
            return {
                id: commitment.contractedContact.id,
                name: '<strong>' + commitment.contractedContact.get('companyName') + '</strong>',
                subtext: commitment.contractedContact.get('contactName') ?? ''
            };
        };
        this.companyPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.batch.requests, {
            pickerSelector: '.select-company',
            valueAttribute: 'contractedContactId',
            idAttribute: 'id',
            selectPickerOptions: {
                isBlockSubtext: true,
                size: 5,
                isIntChoices: true,
                choices: (model) => {
                    let foundIds = [],
                        suggested = [],
                        others = [],
                        costCodeId = model.lineItem.get('costCodeId') > 0;
                    _.each(this.options.projectCommitments.models, (commitment) => {
                        if (commitment.contractedContact == null || -1 !== foundIds.indexOf(commitment.contractedContact.id)) {
                            return;
                        }

                        if (costCodeId > 0 && null != commitment.lineItems.findWhere({
                            costCodeId: costCodeId
                        })) {
                            suggested.push(commitment);
                        } else {
                            others.push(commitment);
                        }
                    });
                    if (_.size(suggested) > 0) {
                        return [{
                            name: 'Suggested',
                            choices: _.map(suggested, fnVendorToChoice)
                        }, {
                            name: '',
                            choices: _.map(others, fnVendorToChoice)
                        }];
                    }
                    return _.map(others, fnVendorToChoice);
                }
            },
            onChange: (model, value) => {
                let commitment = null,
                    currentCommitment = this.options.projectCommitments.get(model.commitmentId),
                    matchCommitments;
                if (currentCommitment?.contractedContact?.id === value) {
                    commitment = currentCommitment
                    matchCommitments = this.options.projectCommitments.filter((commitment) => {
                        return commitment.contractedContact && commitment.contractedContact.id === value;
                    });
                } else {
                    matchCommitments = this.options.projectCommitments.filter((commitment) => {
                        return commitment.contractedContact && commitment.contractedContact.id === value;
                    });
                }

                let contractedContact = null;
                if (_.size(matchCommitments) > 0) {
                    contractedContact = matchCommitments[0].contractedContact ?? matchCommitments[0].invoiceContact;
                }
                model.commitment = commitment;
                model.commitmentId = commitment?.id;
                model.commitmentNumber = model.commitment?.get('number');
                model.contractedContact = contractedContact;
                model.assignees = contractedContact ? [contractedContact] : [];
                model.assigneeIds = contractedContact? [contractedContact.id] : [];
                model.contractedContactId = model.contractedContact?.id;

                this.renderDataTable();
            }
        });
    },
    getColumns: function () {
        return [
            {
                "data": "send",
                "columnData": "send",
                "title": 'Send',
                "orderable": false,
                "searchable": false,
                "render": (data, type, row) => {
                    if (type === 'sort') {
                        return data.id;
                    }

                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' data-p-bind="send" data-id="' + row.id + '" class="cb-send"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                },
                "width": '4%'
            },
            {
                "columnData": "scope",
                "data": "scope",
                "title": "Scope",
                "render": (data, type, row) => {
                    return '<input type="text" class="form-control" data-id="' + row.id + '" value="' + data.replace(/"/g, '&quot;') + '" data-p-bind="scope">';
                }
            },
            {
                "columnData": "contractedContact",
                "title": `Company ${PJQ.constants.markup.requiredAst}`,
                "width": "15%",
                "render": (data, type, row) => {
                    return "<div class='d-flex align-items-center'><select class='form-control select-company'></select></div>";
                }
            },
            {
                "columnData": "commitmentId",
                "title": `Commitment ${PJQ.constants.markup.requiredAst}`,
                "width": "20%",
                "render": (data, type, row) => {
                    return '<div class="d-flex"><select class="form-control select-commitment"></select></div>';
                }
            },
            {
                "columnData": "assignees",
                "title": "Assignees",
                "width": "20%",
                "visible": false,
                "render": (data, type, row) => {
                    return '<div class="d-flex"><select class="form-control select-assignees"></select></div>';
                }
            },
            {
                data: "id",
                title: "",
                orderable: false,
                searchable: false,
                width: 50,
                className: 'text-align-center',
                render: (data, type, row) => {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-danger btn-delete-line-item ml-1"><i class="fal fa-trash"></i></button></div>';
                }
            }
        ];
    },
    sendChanged: function(e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            request = _.findWhere(this.batch.requests, {
                id: id
            });

        if(request){
            request.send = $target.prop('checked');
        }
    },
    renderDataTable: function () {
        let data = _.sortBy(this.batch.requests, (model) => {
            return model.id;
        });
        let $dataTable = this.$('.line-items-table')
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: $dataTable,
            data: data,
            rowId: 'id',
            order: [],
            // autoWidth: false,
            // fixedHeader: {
            //     header: false,
            //     footer: false
            // },
            // hasFooter: true,
            // extraClasses: this.isInvoices ? 'table-invoice-line-items' : '',
            isHideSearch: true,
            paging: false,
            // order: [],
            // language: {
            //     emptyTable: this.options.canEdit ? 'Click "Add Line Item" to create a new Line item' : 'No line items have been added yet'
            // },
            columns: this.getColumns(),
            afterDataTableRender: () => {
                this.renderInputs();
            },
            onRowRemoved: () => {
                this.renderInputs();
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteLineItem(row);
                        }
                    }
                ]
            },
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    deleteLineItem: function (row) {
        if (row == null) {
            return;
        }

        let item = row.data();
        this.batch.requests = _.reject(this.batch.requests, (request) => {
            return request.id === item.id;
        });
        this.render();
    },
    validateBatchItem: function(batchItem){
        if (this.dataTable == null) {
            return true;
        }

        let row = this.dataTable.getRow(batchItem.cid),
            data = row.data(),
            result = true,
            updateCell = _.bind(function ($cell, isValid) {
                if (isValid) {
                    $cell.removeClass('bg-danger-transparent');
                } else {
                    $cell.addClass('bg-danger-transparent');
                }
                result = result && isValid;
            }, this);

        if (data == null) {
            return true;
        }
        if (row != null) {
            let companyCol = 2,
                commitmentCol = 3,
                companyNode = $(row.nodes()[0]).find(`td:eq(${companyCol})`),
                commitmentNode = $(row.nodes()[0]).find(`td:eq(${commitmentCol})`);

            updateCell(companyNode, data.contractedContact != null);
            updateCell(commitmentNode, data.commitmentId != null);
        }

        return result;
    },
    validate: function () {
        let isValid = true;

        _.each(this.batch.requests, function (request) {
            isValid = isValid && this.validateBatchItem(request);
        }, this);

        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        let loader = new PJQ.Loader(this.$('.modal-content'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'rfq'
                },
                {
                    endpoint: 'batch'
                }]),
            isAPIv2: true,
            data: {
                changeRequestId: this.batch.changeRequestId,
                attachments: this.batch.attachments.toJSON(),
                requests: _.map(this.batch.requests, (req) => {
                    return _.defaults({
                        id: null,
                        title: this.batch.title,
                        description: this.batch.description,
                        dueDate: this.batch.dueDate
                    }, req);
                })
            }
        }).post().done((batchRes) => {
            if (_.size(batchRes.requests) > 0) {
                PJQ.notifications.notify.successNotify({
                    message: _.size(batchRes.requests).toString() + ' RFQs were created'
                });
            } else {
                PJQ.notifications.notify.warningNotify({
                    message: 'No RFQs were created'
                });
            }
            if (typeof this.options.onSave === 'function') {
                this.options.onSave(batchRes);
            }
            this.removeModal();
        }).fail((err) => {
            loader.remove();
            PJQ.notifications.notify.warningNotify({
                message: 'Encountered an error while creating RFQs. Please contact customer service.'
            });
        });
    },
    close: function () {
        new PJQ.views.modals.YesNo({
            header: "Cancel creating RFQs?",
            body: "Are you sure you want to cancel creating RFQs? All unsaved changes will be lost.",
            onYes: () => {
                this.removeModal();
            }
        });
    }
});